<template>
  <div>
    <div class="page-content">
      <div class="page-box">
        <div class="page-box-content">
          <Row type="flex" justify="space-between">
            <Col>
              <i-form inline>
                <FormItem>
                  <Select v-model="where.status" :placeholder="$t('name.cex_take.status')">
                    <Option v-for="(item, key) in $t('name.cex_take.status_text')" :value="key" :key="key">{{ item }}</Option>
                  </Select>
                </FormItem>
                <FormItem>
                  <Input v-model="where.name" :placeholder="$t('name.cex_take.name')" style="width: 120px" />
                </FormItem>
                <FormItem>
                  <Input v-model="where.code" :placeholder="$t('name.cex_take.code')" style="width: 120px" />
                </FormItem>
                <FormItem>
                  <DatePicker type="daterange" placement="bottom-end" :placeholder="$t('name.cex_take.created_at')" v-model="daterange" @on-change="onTime" :clearable="false" />
                </FormItem>
                <FormItem>
                  <Button type="primary" icon="md-search" @click="search">{{ $t('name.search') }}</Button>
                </FormItem>
              </i-form>
            </Col>
            <Col>
              <Button type="primary" icon="md-notifications" @click="$refs.create.open()" ghost style="margin-right: 10px">{{ $t('name.cex_take.create.title') }}</Button>
              <Button type="warning" icon="md-notifications-outline" @click="$refs.no.open()" ghost>{{ $t('name.cex_take.active_no') }}</Button>
            </Col>
          </Row>
          <Table ref="table" :list="list" @get="getData" />
          <div class="page-box-content" style="text-align:center">
            <Page 
              :current.sync="where.page" 
              :total="total" 
              :page-size="size" 
              @on-change="getData" 
              show-total 
              show-elevator 
            />
          </div>
        </div>
      </div>
    </div>
    <Create ref="create" @create="getData" />
    <No ref="no" />
  </div>
</template>
<script>
import Create from './create'
import Table from './table'
import No from './no'
import { user } from '@/api/cex_take';

export default {
  components:{
    Create,
    Table,
    No
  },
  data() {
    return {
      cex: [],
      list: [],
      total: 0,
      size: 0,
      where: {
        page: 1,
        name: null,
        code: null,
        status: null,
        time: null
      },
      // 日期选择
      daterange: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 获取最新配置
    getData() {
      user(this.where).then(res => {
        this.list = res.data
        this.where.page = res.current_page
        this.total = res.total
        this.size = res.per_page
      })
    },
    
    // 搜索
    search() {
      this.where.page = 1
      this.getData()
    },
    
    // 选择时间
    onTime() {
      this.where.time = [this.daterange[0].getTime() / 1000, this.daterange[1].getTime() / 1000 + (60 * 60 * 24)]
    }
  },
};
</script>